import React, { useState, useEffect } from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { EMPTY_OBJECT } from './AddTaskList'

function RunCustomSqlStatement(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [databaseId, setDatabaseId] = useState(-1)
    const [dataSourceSystemName, setDataSourceSystemName] = useState('')
    const [sqlStatement, setSqlStatement] = useState('')
    const [databaseName, setDatabaseName] = useState('')
    const [sqLDbList, setSqLDbList] = useState([])
    const [dataSources, setDataSources] = useState([])

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)

            let getDataSources = props.getDataSources(props.taskData.databaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDataSources(json)
                setIsLoadingRequest(false)
                setDataSourceSystemName(props.taskData.dataSourceSystemName)
            }).catch((ex) => {
                console.error(ex)
                setDataSources([])
                setIsLoadingRequest(false)
            })

            setDatabaseName(props.taskData.databaseName)
        } else {
            setDatabaseId(-1)
            setDatabaseName('')
            setDataSourceSystemName('')
        }

        if (props.taskData.rawSql && props.taskData.rawSql.trim().length > 0) {
            setSqlStatement(props.taskData.rawSql)
        } else {
            setSqlStatement('')
        }
    }, [])

    useEffect(() => {
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)

            let getDataSources = props.getDataSources(props.taskData.databaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setDataSources(json)
                setIsLoadingRequest(false)
                setDataSourceSystemName(props.taskData.dataSourceSystemName)
            }).catch((ex) => {
                console.error(ex)
                setDataSources([])
                setIsLoadingRequest(false)
            })

            setDatabaseName(props.taskData.databaseName)
            
            if (props.taskData.rawSql && props.taskData.rawSql.trim().length > 0) {
                setSqlStatement(props.taskData.rawSql)
            } else {
                setSqlStatement('')
            }
        } else {
            setDatabaseId(-1)
            setDataSourceSystemName('')
            setSqlStatement('')
            setIsLoadingRequest(false)
            setDataSources([])
            setDatabaseName('')
        }
    }, [props.taskData.databaseId])

    function handleDatabase(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setDataSourceSystemName('')
        setSqlStatement('')
        setIsLoadingRequest(true)
        setDataSources([])
        setDatabaseName('')

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            let dbName = ''
            sqLDbList.forEach(db => {
                if (db.id === event.target.value) {
                    setDatabaseName(db.dBname)
                    dbName = db.dBname
                }
            })
            setDataSources(json)
            setIsLoadingRequest(false)
            fireOnSaveEvent(event.target.value, dbName, "", "", "")
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setIsLoadingRequest(false)
        })
    }

    function handleDataSourceChange(event) {
        event.preventDefault()
        setDataSourceSystemName(event.target.value)

        dataSources.forEach((ds) => {
            if (ds.key === event.target.value) {
                fireOnSaveEvent(databaseId, databaseName, event.target.value, ds.value, "")
            }
        })
    }

    /**
     * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     * @param {string} dsSystemName - Data source system name from the selected database
     * @param {string} dsName - What we are renaming the data source
     * @param {string} rawSql - SQL Syntax
     */
    function fireOnSaveEvent(dbId, dbName, dsSystemName, dsName, rawSql) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["dataSourceSystemName"] = dsSystemName
            copied["dataSourceName"] = dsName
            copied["rawSql"] = rawSql
            props.onSave(copied)
        }
    }

    // This is the render logic, no need to declare another method is a functional component
    return (
        <Paper elevation={3} className="dbFunctionsPaper">
            <h3>Raw SQL Statement</h3>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-databse-label">Select Database</InputLabel>
                <Select
                    labelId="select-databse-label"
                    id="select-databse"
                    label="Select Database"
                    onChange={handleDatabase}
                    defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                    value={databaseId}
                    displayEmpty
                    required
                    inputProps={{ 'aria-label': 'Without label' }}
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select Database</MenuItem>
                        { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-data-source-label">Select Data Source</InputLabel>
                <Select
                    labelId="select-data-source-label"
                    id="select-data-source"
                    label="Select Data Source"
                    onChange={handleDataSourceChange}
                    value={dataSourceSystemName}
                    defaultValue={''}
                    displayEmpty
                    required
                    inputProps={{ 'aria-label': 'Without label' }}
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={''}>Select Data Source</MenuItem>
                        { dataSources.map((x) => x && <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>) }
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <TextField
                    fullWidth
                    label="SQL Statement"
                    variant="outlined"
                    multiline
                    rows={4}
                    value={sqlStatement}
                    disabled={isLoadingRequest}
                    onChange={(e) => {
                        e.preventDefault()
                        setSqlStatement(e.target.value)
                        fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, "", e.target.value)
                }} />
            </FormControl>
        </Paper>
    )
}

export default RunCustomSqlStatement